export const pageStyle = {
  width: '100%',
  height: 'calc(100vh - 70px)',
  minHeight: 'calc(100vh - 70px)',
  display: 'flex',
  flexDirection: 'column',
  background: 'linear-gradient(180deg, #f4f8fb 0%, #eef4f8 100%)',
  overflowY: 'auto',
};

export const stageStyle = {
  flex: 1,
  position: 'relative',
  minHeight: 0,
};

export const panelStyle = {
  border: 'none',
  borderRadius: 0,
  background: '#111111',
  overflow: 'hidden',
  minHeight: 0,
  boxShadow: 'none',
};

export const localPanelStyle = {
  ...panelStyle,
  display: 'none',
};

export const remotePanelStyle = {
  ...panelStyle,
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
};

export const footerStyle = {
  borderTop: 'none',
  padding: 0,
  background: 'transparent',
};

export const controlRowStyle = {
  position: 'absolute',
  bottom: 16,
  left: '50%',
  transform: 'translateX(-50%)',
  zIndex: 3,
};

export const mockTileStyle = {
  width: '100%',
  height: '100%',
  minHeight: 260,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  color: '#ffffff',
  fontWeight: 600,
};

export const chipStyle = {
  display: 'inline-block',
  marginLeft: 8,
  padding: '2px 8px',
  borderRadius: 999,
  background: '#eef3fb',
  color: '#486182',
  border: '1px solid #d4e1f4',
  fontSize: 11,
  fontWeight: 700,
};

export const secondaryButtonStyle = {
  border: '1px solid #c8d6e3',
  background: '#ffffff',
  color: '#21374d',
  borderRadius: 999,
  height: 40,
  padding: '0 16px',
  fontSize: 13,
  fontWeight: 600,
  cursor: 'pointer',
};
